import CoverLink from "components/Cover/CoverLink";
import { LetterbookLibraryType } from "features/Letterbooks/types";

export default function LetterbookUserBookShelfRow({
  letterbook,
}: {
  letterbook: LetterbookLibraryType;
}) {
  const { book } = letterbook;
  const { ownerUserBook } = letterbook.data;

  return (
    <div className="flex flex-row">
      <CoverLink size="md" book={book} edition={ownerUserBook?.edition} />
    </div>
  );
}
